export default interface TableHeader {
  text: string;
  value: string;
  align?: "start" | "center" | "end";
  sortable?: boolean;
  filterable?: boolean;
  groupable?: boolean;
  divider?: boolean;
  class?: string | string[];
  width?: string | number;
  filter?: (value: any, search: string, item: any) => boolean;
  sort?: (a: any, b: any) => number;
  format?: (value: any) => string;
}

export const DefaultActionsHeader: TableHeader = {
  text: "Actions",
  value: "actions",
  sortable: false,
};
